// Google analytics tools
initGA();

// Sidr
//initSidr();

// ShowHide
initShowHide();

// Slide link
initSlidelink();

// Carousel
initCarousel();

/**
 * Method: hasVerticalScroll
 *
 * @param mixed node
 * @return void
 */
function hasVerticalScroll(node) {
  if (node == undefined) {
    if (window.innerHeight) {
      return document.body.offsetHeight > window.innerHeight;
    } else {
      return document.documentElement.scrollHeight >
        document.documentElement.offsetHeight ||
        document.body.scrollHeight > document.body.offsetHeight;
    }
  } else {
    return node.scrollHeight > node.offsetHeight;
  }
}

/**
 * Method: initGA
 *
 * @return void
 */
function initGA()
{
  // Events
  $('*[data-ga-click]').on('click', function(event) {
    var data = {
      eventCategory: $(this).data('ga-click'),
      eventAction: 'click',
      eventLabel: event.target.href,
      transport: 'beacon'
    };
    ga('send', 'event', data);
  });
}

/**
 * Method: initSidr
 *
 * @return void
 */
function initSidr()
{
  $('.sidr-trigger').sidr({
    renaming: true
  });
}

/**
 * Method: initShowHide
 *
 * @return void
 */
function initShowHide()
{
  $('.showhide').on('click', function() {
    $(this).toggleClass('open');
  });
}

/**
 * Method: initCarousel
 *
 * @return void
 */
function initCarousel()
{
  var carousel = $('.carousel');
  carousel.find('.carousel-item').first().addClass('active');
  var id = 'whatever';
  carousel.append(
    '<a class="carousel-control-prev" href="#' + id +'" data-slide="prev">' +
    '<span class="fa fa-angle-left" aria-hidden="true"></span>' +
    '</a>' +
    '<a class="carousel-control-next" href="#' + id +'" data-slide="next">' +
    '<span class="fa fa-angle-right" aria-hidden="true"></span>' +
    '</a>'
  );
  carousel.attr('id', id);
  carousel.carousel();
}

/**
 * Method: initSlidelink
 *
 * @return void
 */
function initSlidelink() 
{
  function scroll(hash)
  {
      $('html,body').animate({scrollTop: $(hash).offset().top - 90},'slow');
  }

  $(".main-menu a").click(function(e) {
    var _this = $(this);
    var hash = this.hash;
    var li = _this.parents('li');

    if (li.hasClass('active') && hash.length) {
      e.preventDefault();
      scroll(hash);
    }
  });

  var onLoadHash = window.location.hash;
  if (onLoadHash !== '') {
    scroll(onLoadHash);
  }
}

// forEach dirty fix for IE
(function () {
  if ( typeof NodeList.prototype.forEach === "function" ) return false;
  NodeList.prototype.forEach = Array.prototype.forEach;
})();

// global, shared javascript
$(document).ajaxSend(function(event, request, settings) {
  // add ajax class only when request is not resolved quickly (to show loading effect)
  setTimeout(function() {
    if (request.readyState != 4) {
      $('body').addClass('ajax');
    }
  }, 300);
  // setting headers
  let csrfToken = document
    .querySelector('meta[name="X-CSRF-Token"]')
    .getAttribute('content');
  request.setRequestHeader("X-CSRF-Token", csrfToken);
});
$(document).ajaxComplete(function(event, request, settings) {
  $('body').removeClass('ajax');
});

